// Angular
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { filter, cloneDeep } from 'lodash';

export interface FilterOption {
  id?: number;
  field: string;
  title: string;
  value: any;
  value2?: any;
  inputType: string;
  type: string;
  sort: string;
  nonDisplayFilter?: boolean;
}

@Component({
  selector: 'filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
})
export class FiltersComponent implements OnInit {
  @Input() savedFilters: any = {};
  @Input() selectedFilters: FilterOption[] = [];
  @Input() filterOptions: FilterOption[] = [];
  @Input() formGroup: UntypedFormGroup;
  @Output() applied: EventEmitter<FilterOption[]> = new EventEmitter();
  @Output() saved: EventEmitter<any> = new EventEmitter();
  @Output() closed: EventEmitter<any> = new EventEmitter();
  dropdownOptions(inputType: string): any[] {
    try {
      const options = JSON.parse(inputType);
      return Array.isArray(options) ? options : [];
    } catch {
      return [];
    }
  }
  private presetModal: ReturnType<NgbModal["open"]>;

  constructor(private fb: UntypedFormBuilder, private modalService: NgbModal) { }

  ngOnInit() {
    this.formGroup = this.fb.group({ newField: [''] });
  }

  addFilter() {
    const option = this.filterOptions.find(option => option.field === this.formGroup.value.newField);
    if (option) this.selectedFilters.push(cloneDeep(option));
    this.formGroup.setValue({ newField: '' });
  }

  isSelected(field: string) {
    return this.selectedFilters.some(filter => filter.field == field);
  }

  removeFilter(evt, option: FilterOption) {
    evt.stopPropagation();
    this.selectedFilters.splice(this.selectedFilters.findIndex(item => item.field === option.field), 1);
  }

  applyFilters(filterName: string = null) {
    if (filterName)
      this.selectedFilters = cloneDeep(this.savedFilters[filterName]);
    this.applied.emit(this.selectedFilters);
  }

  saveFilters(saveModal: any) {
    this.presetModal = this.modalService.open(saveModal);
    this.presetModal.result.catch(() => {});
  }

  save(name: string) {
    this.savedFilters[name] = cloneDeep(this.selectedFilters);
    this.applied.emit(this.selectedFilters);
    this.saved.emit(this.savedFilters);
    this.presetModal?.close();
  }

  setType(evt, option: FilterOption, value: string) {
    evt.stopPropagation();
    option.type = value;
  }

  getAllFilters() {
    return Object.keys(this.savedFilters);
  }

  softClose(select: any) {
    setTimeout(() => select.close(), 1);
  }

  getDisplayFilters(filters: FilterOption[]) {
    return (filters || []).filter(filter => filter && !filter.nonDisplayFilter && filter.inputType)
  }
}
